module.exports = __webpack_public_path__ + "static/fruits-747795116e3c0680b78082c88ca57a59.jpg";